import type { ReactNode } from "react";
import { useContext, createContext } from "react";
import type { UnknownPageRegistration } from "~/routing/pageRegistrations/PageRegistration";
import type { CompleteWorkflow } from "~/workflows/workflowRegistrations";
import type { Workflow } from "~/workflows/workflows";
const startWorkflowContext = createContext<StartWorkflowContext | null>(null);
export type StartWorkflowContext = <Input, Output>(input: Input, workflow: Workflow<Input, Output>, onWorkflowCompleted: CompleteWorkflow<Output>, abortSignal: AbortSignal, pageRegistration: UnknownPageRegistration | null) => void;
export function StartWorkflowProvider({ value, children }: {
    value: StartWorkflowContext;
    children: ReactNode;
}) {
    return <startWorkflowContext.Provider value={value}>{children}</startWorkflowContext.Provider>;
}
/**
 * Internal infrastructure-level hook used to obtain a function that can be used to start a workflow.
 * If you are trying to start a workflow, use `useWorkflow` instead.
 */
export function useStartWorkflowInternal() {
    const startWorkflow = useContext(startWorkflowContext);
    if (startWorkflow === null) {
        throw new Error("Provider for startWorkflowContext was not found.");
    }
    return startWorkflow;
}
